import React from 'react';
import { EmptyState } from '../../../../../components/EmptyState';
import { Button } from 'reactstrap';
import { CollapsableText } from '../../../../../components/CollapsableText';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface PropTypes {
  summary?: string;
  handleAskAI: () => void;
  isAiGenerating: boolean;
}

export function SummaryPreview(props: PropTypes) {
  return (
    <>
      <div className='d-flex justify-content-between'>
        <div className='fw-semibold fs-5'>Summary Preview</div>
        <Button size='sm' color='borderless' onClick={props.handleAskAI}>
          Regenerate
        </Button>
      </div>
      {props.summary == null ? (
        <EmptyState
          title='No preview generated yet'
          text='Add new topics, exclude existing ones or change the length to generate and preview your new summary.'
          cardless={true}
          classNames='col-8'
        />
      ) : (
        <div
          className={classNames(
            'bg-gray',
            'fs-5',
            'py-2',
            'px-3',
            'rounded-2',
            styles.summary,
          )}
        >
          <CollapsableText
            collapseWords={50}
            maxWords={350}
            expandWordsStep={100}
            text={props.summary}
          />
        </div>
      )}
    </>
  );
}
